const initstate = {
  fname: "",
  regno: "",
  degree: "",
  collname: "",
  fappno: "",
  fcatcode: "",
  freccer: "",
  fnational: "",
  fmobile: "",
  famount: "",
  fpaytype: "",
  fpaydate: "",
  ftranid: "",
  postadd1: "",
  postadd2: "",
  city: "",
  state: "",
  pincode: "",
  contry: "",
  aadahr: "",
  fdob: "",
  femail: ""
};

export const convoRecDet = (state = [], action) => {
  switch (action.type) {
    case "CONVO_COLL_REC":
      return action.payload.data;

    case "CHANGE_CONVO_DETAILS":
      const { name, value } = action.payload;
      return { ...state, [name]: value };
    case "CONVO_CLEAR":
      return initstate;
    default:
      return state;
  }
};
